import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import ModalRow from '@web/timeClock/modals/rows/ModalRow/ModalRow';
import LocationIconSvg from '@web/assets/svg/Icons/32/location-gray.svg';
import { RowText } from '@web/timeClock/modals/rows/LocationRow/LocationRow.styles';

type Props = {
  location: {
    name: string;
  };
};

const LocationRow = ({ location }: Props) => (
  <ModalRow label={gettext('Location')} icon={LocationIconSvg}>
    <RowText themeColor={ThemeColorType.gray}>{location.name}</RowText>
  </ModalRow>
);

export default LocationRow;
